import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOrReplaceAllMembershipQuestionsRequest = {};
var _createOrReplaceAllMembershipQuestionsResponse = {};
var _listAnswersRequest = {};
var _listAnswersResponse = {};
var _listMembershipQuestionsRequest = {};
var _listMembershipQuestionsResponse = {};
function resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves the membership questions for the given group. */
export function listMembershipQuestions(payload) {
    return function __listMembershipQuestions(_a) {
        var host = _a.host;
        var toJSON = serializer(_listMembershipQuestionsRequest, {}).toJSON;
        var fromJSON = serializer(_listMembershipQuestionsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                protoPath: '/v2/membership-questions/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Creates membership questions if none have been set up. Otherwise, replaces all existing questions.
 * > **Notes:**
 * > * Only admins can create or replace membership questions.
 * > * Providing an empty array means that members won't have to answer any question when joining the group.
 */
export function createOrReplaceAllMembershipQuestions(payload) {
    return function __createOrReplaceAllMembershipQuestions(_a) {
        var host = _a.host;
        var toJSON = serializer(_createOrReplaceAllMembershipQuestionsRequest, {}).toJSON;
        var fromJSON = serializer(_createOrReplaceAllMembershipQuestionsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                protoPath: '/v2/membership-questions/{groupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Retrieves the answers to the membership questions, given the provided filters. */
export function listAnswers(payload) {
    return function __listAnswers(_a) {
        var host = _a.host;
        var toJSON = serializer(_listAnswersRequest, {}).toJSON;
        var fromJSON = serializer(_listAnswersResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                protoPath: '/v2/membership-questions/{groupId}/answers',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map